(() => {
  const controllers = new Map();

  function mount(drawer) {
    if (controllers.has(drawer)) return;
    const groups = [...drawer.querySelectorAll('[data-thl-accordion]')];
    if (!groups.length) return;
    const root = drawer.querySelector('[data-primary-container]');

    function setExpanded(group, expanded) {
      const toggle = group.querySelector('[data-thl-accordion-toggle]');
      const content = group.querySelector('[data-thl-accordion-content]');
      if (!toggle || !content) return;
      toggle.setAttribute('aria-expanded', String(expanded));
      content.hidden = !expanded;
      group.classList.toggle('is-collapsed', !expanded);
    }

    function onClick(event) {
      const toggle = event.target.closest('[data-thl-accordion-toggle]');
      if (!toggle || !drawer.contains(toggle)) return;
      const group = toggle.closest('[data-thl-accordion]');
      setExpanded(group, toggle.getAttribute('aria-expanded') !== 'true');
    }

    groups.forEach(group => setExpanded(group, true));
    drawer.addEventListener('click', onClick);
    const observer = new MutationObserver(() => {
      if (root?.dataset.depth === '0') groups.forEach(group => setExpanded(group, true));
    });
    if (root) observer.observe(root, { attributes: true, attributeFilter: ['data-depth'] });
    controllers.set(drawer, () => {
      drawer.removeEventListener('click', onClick);
      observer.disconnect();
    });
  }

  function mountAll() {
    for (const [drawer, cleanup] of controllers) {
      if (!drawer.isConnected) { cleanup(); controllers.delete(drawer); }
    }
    document.querySelectorAll('[data-drawer-menu]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    for (const [drawer, cleanup] of controllers) {
      if (event.target.contains(drawer)) { cleanup(); controllers.delete(drawer); }
    }
  });
})();
